import { el } from 'redom';

import FilterEditor from '../filter-editor';

import './index.scss';

class FilterSelector {

  constructor(configuration) {

    this.filterPanel = null;
    this.application = configuration.application;
    this.onSelect = configuration.onSelect;
    this.pageId = configuration.pageId;
    this.collectionId = configuration.collectionId;
    this.filterId = configuration.filterId;

    this.filtersManager = this.application.dataManagers.get('DataCollectionFiltersManager');

    const filter = this.filtersManager.getAll(this.collectionId).filter((filter) => filter._id === this.filterId)[0];

    this.el = el('.data-collection-filter-selector-main', [
      el('label.side-value-control-label.field-label', 'Filter records'),
      el('button.filter-editor.ellipsis', {
        onclick: () => {

          this.editFilter(filter);
        }
      }, filter?.name)
    ]);

  }

  async updateFilter(filter) {

    await this.filtersManager.update(this.collectionId, filter._id, {
      ...filter,
      criteria: filter.value
    });

    return filter;

  }

  handleSave(filter) {

    this.onSelect(filter._id);

    this.filterPanel.hide();

  }

  async editFilter(filter) {

    this.filterPanel = new FilterEditor({
      application: this.application,
      collectionId: this.collectionId,
      mode: FilterEditor.modes.EDIT,
      filter,
      saveFilter: this.updateFilter.bind(this),
      onSave: this.handleSave.bind(this),
      onDelete: () => {},
      disableDelete: true
    });

    this.filterPanel.show();

  }

  update(configuration) {

    this.onSelect = configuration.onSelect;

  }

}

export default FilterSelector;